<template>
<m-pageframe
    title="Telephone Number Tools"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
>
    <v-text-field
        label="Phone Number"
        v-model="endpoint"
        autofocus
    />

    <v-btn
        :disabled="!is_valid_endpoint"
        v-on:click="onClickCheckHostedMessagingAvailability"
    >
        Check Hosted Messaging Availability...
    </v-btn>

    <br/><br/>

    <v-btn
        :disabled="!is_valid_endpoint"
        v-on:click="onClickCarrierLookup"
    >
        Carrier Lookup...
    </v-btn>

</v-container>
</m-pageframe>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {
    data() {
        return {
            endpoint: '315-265-6106',
        }
    },
    
    methods: {
        onClickCheckHostedMessagingAvailability() {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/admin/check-hosted-messaging',
                'timeout' : 45000,
            
                'params' : {
                        'endpoint': this.endpoint
                    },
            
                'on_success': (data) => {
                        this.$rc.alert({
                            'title': "Ability to Host Messaging",
                            'text': "<p><b>Can Host Messaging:</b> "+(data.can_host ? 'Yes' : 'No')+"</p>"+
                            "<p><b>Details:</b> "+(data.error_message ?? 'none')+"</p>",
                            'technical_details': data.technical_details,
                        });
                    },
            
                'on_error': 'Unable to check hosted messaging availability',
            });
        },

        onClickCarrierLookup()
        {
            this.$rc.startProcess({
                'type': 'tn-get-carrier-information',
            
                'params': {
                    'endpoint': this.endpoint
                },
            
                'title': 'Get Carrier Information',
                'finished_button_text': 'Proceed',
                'failed_button_text': 'Cancel',
                'auto_proceed': true,
            
                status: (pte) => {
                    if ( pte.output != null )
                    {
                        return pte.output.foo;
                    }

                    return 'Getting carrier information';
                },
            
                on_finished: (pte) => {
                    
                    this.$rc.technicalDetails({
                        'title': 'Phone Number Carrier Information',
                        'technical_details': pte.output.technical_details,
                    });

                },
            
                on_failed: (pte) => {
                    this.$rc.alert('Error','Unable to lookup carrier information');
                },
            
            });
        },
    },

    computed: {
        is_valid_endpoint() {
            return E164.isUSPhoneNumber(this.endpoint);
        }
    },
}
</script>

<style lang="scss" scoped>
</style>